import { Component, Input, OnInit } from '@angular/core';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';
import { IconColor } from '../avatar/avatar.component';

@Component({
  selector: 'app-form-button[icon]',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class FormButtonComponent implements OnInit {
  @Input() color: IconColor = 'primary';
  @Input() icon!: string;
  @Input() textKey: LocLabel | string | null = null;
  @Input() border = false;

  constructor() {}

  ngOnInit(): void {}
}
